import * as Sentry from '@sentry/react'
import { browserTracingIntegration, replayIntegration } from '@sentry/react'

const isProduction = import.meta.env.PROD || import.meta.env.MODE === 'production'

if (isProduction) {
  Sentry.init({
    dsn: 'https://f0f107303c1545e0b2e4b04b52ed9bcc@sentry10.ultimate-guitar.com/53',
    environment: 'production',
    tracesSampleRate: 0.1,
    integrations: [browserTracingIntegration(), replayIntegration()],
    attachStacktrace: true,
    normalizeDepth: 3,
  })
}
